// Remembers, for the current tab, where the visitor came from so the contact
// form can say which page led to the request (read by Hermes seo-watch to
// attribute each lead to its landing page).
//
// Only paths are kept, never query strings, and nothing leaves the browser
// until the visitor submits the contact form. sessionStorage dies with the tab.
const KEY = "sxn-visit-trail";

const read = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

const write = (trail) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(trail));
  } catch {
    // Storage disabled: the form simply goes out without the fields.
  }
};

const externalReferrer = () => {
  try {
    const url = new URL(document.referrer);
    return url.host === location.host ? null : `${url.origin}${url.pathname}`;
  } catch {
    return null;
  }
};

export const recordVisit = () => {
  const trail = read();
  const path = location.pathname;

  trail.landing ||= path;
  trail.referrer ||= externalReferrer();
  if (trail.current && trail.current !== path) trail.previous = trail.current;
  trail.current = path;

  write(trail);
};

export const visitTrail = read;
